export default function ($rootScope) {
    'ngInject';
    return {
        restrict: 'A',
        link: (scope, element) => { // TODO: Separate controller from directive
            scope.$watch(element[0].clientWidth,
                () => {
                    $rootScope.$emit('resize');
                }
            );
            $(window).on('resize', () => {
                $rootScope.$emit('resize');
            });
        }
    };
}



// WEBPACK FOOTER //
// ./src/js/directives/verticalScroll.js